import { trpc } from '@/shared/api';

/** 카테고리 트리(대분류·소분류) 조회. */
export const useCategoriesQuery = () => trpc.productManagement.categories.list.useQuery();
